export default __webpack_public_path__ + "static/media/event-details-background.50308672.svg";